(function () {
  function initHero(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-nk-slide]'));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-nk-dot]'));
    var prev = root.querySelector('[data-nk-prev]');
    var next = root.querySelector('[data-nk-next]');
    var current = 0;
    var delay = parseInt(root.getAttribute('data-autoplay'), 10) * 1000;
    var timer = null;

    function show(n) {
      current = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
    }
    function start() {
      if (!delay) return;
      stop();
      timer = setInterval(function () { show(current + 1); }, delay);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    if (next) next.addEventListener('click', function () { show(current + 1); start(); });
    if (prev) prev.addEventListener('click', function () { show(current - 1); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-index'), 10)); start(); });
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    start();
  }
  function boot() {
    document.querySelectorAll('[data-nk-hero]').forEach(initHero);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  // Re-init inside Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-nk-hero]').forEach(initHero);
  });
})();
